// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `  .fc-timegrid-slot {
    border-top: 1px solid #EFEFEF !important;
  }
  
  .fc-timegrid-slot-lane {
    border-top: 1px solid #EFEFEF !important;
    border-right: 1px solid #EFEFEF !important;
  }
  
  .fc-timegrid-slot-label {
    border-top: 1px solid #EFEFEF !important;
  }
  `, "",{"version":3,"sources":["webpack://./src/modules/Events/WeekView/Style/CalendarComponent.css"],"names":[],"mappings":"EAAE;IACE,wCAAwC;EAC1C;;EAEA;IACE,wCAAwC;IACxC,0CAA0C;EAC5C;;EAEA;IACE,wCAAwC;EAC1C","sourcesContent":["  .fc-timegrid-slot {\n    border-top: 1px solid #EFEFEF !important;\n  }\n  \n  .fc-timegrid-slot-lane {\n    border-top: 1px solid #EFEFEF !important;\n    border-right: 1px solid #EFEFEF !important;\n  }\n  \n  .fc-timegrid-slot-label {\n    border-top: 1px solid #EFEFEF !important;\n  }\n  "],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
